import * as d3 from 'd3'
import _ from 'underscore'

let Chart = function () {
    var svg = null

    var dimensions = {
        width: 0,
        height: 0,
    }

    var margin = {
        top: 4,
        right: 0,
        bottom: 4,
        left: 0,
    }

    this.create = function (rootElement, width, height) {
        svg = rootElement
        dimensions.width = width
        dimensions.height = height + margin.top + margin.bottom

        if (width > 150) {
            margin.left = 50
        }

        let d3Svg = d3.select(svg)
            .attr('class', 'sparkline')
            .attr('width', dimensions.width)
            .attr('height', dimensions.height)

        let container = d3Svg.append('g')
            .attr('class', 'container')

        container.append('g')
            .attr('class', 'markers')

        let axis = container.append('g')
            .attr('class', 'axis')

        axis.append('g').attr('class', 'y')
        axis.append('g').attr('class', 'x')

        container.append('g')
            .attr('class', 'lines')
    }

    var _scales = function (lines) {
        return {
            x: d3.scaleTime()
                .domain([_.min(_.pluck(lines[0], 'start')), _.max(_.pluck(lines[0], 'start'))])
                .rangeRound([0, dimensions.width - margin.left - margin.right]),
            y: d3.scaleLinear()
                .domain([Math.max(_.max(_.pluck(lines[0], 'value')), 0.001), 0])
                .range([0, dimensions.height - margin.top - margin.bottom]),
        }
    }

    var _axis = function (scales) {
        return {
            y: d3.axisLeft(scales.y)
                .tickSizeInner(-(dimensions.width - margin.left - margin.right))
                .tickSizeOuter(3)
                .tickPadding(5)
                .ticks(2).tickFormat(d3.format("~s")),
        }
    }

    var _drawAxis = function (scales, axis) {
        var root = d3.select(svg).select('.axis')
        root
            .attr('width', dimensions.width - margin.left - margin.right)
            .attr('height', dimensions.height - margin.top - margin.bottom)
            .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')')

        root.selectAll('.y')
            .call(axis.y)
    }

    var _drawMarkers = function (scales, markers) {
        var root = d3.select(svg).select('.markers')
        root
            .attr('width', dimensions.width - margin.left - margin.right)
            .attr('height', dimensions.height - margin.top - margin.bottom)
            .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')')

        let marker = root.selectAll('g.marker').data(markers)

        // New data
        let newevent = marker.enter()
        let group = newevent.append('g')
            .attr('class', function (marker) { return 'marker ' + marker.type })

        group
            .append('rect')
            .attr('y', 0)
            .attr('height', dimensions.height - margin.top - margin.bottom)

        // Update existing nodes
        marker.select('rect').transition()
            .attr('x', function (marker) { return scales.x(marker.start) })
            .attr('width', function (marker) { return scales.x(marker.end) - scales.x(marker.start) })

        // Exiting node
        marker.exit().remove()
    }

    var _drawData = function (scales, lines) {
        let root = d3.select(svg).select('.lines')

        root
            .attr('width', dimensions.width - margin.left - margin.right)
            .attr('height', dimensions.height - margin.top - margin.bottom)
            .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')')

        let pathFunction = d3.line()
            .x(function (point) { return scales.x(point.start) })
            .y(function (point) { return scales.y(point.value) })
            .curve(d3.curveStepAfter)
        let areaFunction = d3.area()
            .x(function (point) { return scales.x(point.start) })
            .y0(dimensions.height - margin.top - margin.bottom)
            .y1(function (point) { return scales.y(point.value) })
            .curve(d3.curveStepAfter)

        let line = root.selectAll('g.line').data(lines, function (line, index) { return index })

        // New data
        let newLine = line.enter()
        let group = newLine.append('g')
            .attr('class', 'line')

        group
            .append('path')
            .attr('class', 'line')
            .attr('d', function (line) { return pathFunction(line) })
        group
            .append('path')
            .attr('class', 'fill')
            .attr('d', function (line) { return areaFunction(line) })

        // Update existing nodes
        line.select('path.line')
            .attr('d', function (line) { return pathFunction(line) })
            .attr('transform', null)
            .transition()
            .attr('transition', "translate(" + scales.x(-1) + ")")
        line.select('path.fill')
            .attr('d', function (line) { return areaFunction(line) })
            .attr('transform', null)
            .transition()
            .attr('transition', "translate(" + scales.x(-1) + ")")

        // Exiting node
        line.exit().remove()
    }

    var appendValue = function (dataSet) {
        let current = dataSet[dataSet.length - 1]
        let next = _.clone(current)

        next.start = next.end

        dataSet[dataSet.length] = next
        return dataSet
    }

    this.update = function (line, markers) {
        let lines = _.map([line], appendValue)

        let scales = _scales(lines)

        if (margin.left > 0) {
            _drawAxis(scales, _axis(scales))
        }
        _drawMarkers(scales, markers)
        _drawData(scales, lines)
    }

    this.destroy = function () {
    }
}

export default Chart
